// extracted by mini-css-extract-plugin
module.exports = {"sectionLabel":"CookieInformationAccount__sectionLabel___VZM0W","logo":"CookieInformationAccount__logo___SMr4X"};